<p-card header="Attendance Calendar" class="w-full">
  <div class="flex justify-content-between align-items-center mt-3 mb-3">
    <div class="flex align-items-center gap-2">
      <p-splitButton [label]="selectedViewLabel" icon="pi pi-eye" [model]="viewOptions"
        styleClass="p-button-sm custom-split-btn">
      </p-splitButton>

      <p-button label="Export" icon="pi pi-file-export" class="p-button-outlined" (click)="exportAttendance()"
        size="small" [loading]="loader">
      </p-button>
      <p-button label="Cancel" icon="pi pi-times" severity="danger" size="small" (click)="cancel()"></p-button>
    </div>

    <p-button icon="pi pi-refresh" size="small" (click)="refreshAttendance()" [rounded]="true" severity="info"
      pTooltip="Refresh Data">
    </p-button>
  </div>

  <div class="full-calendar-wrapper mt-3">
    <full-calendar [options]="calendarOptions"></full-calendar>
  </div>
</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>